/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Description_PlaceholderInputs */

const th_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำอธิบาย (ไม่บังคับ)`)
};

const en_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description (optional)`)
};

const ja_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明（任意）`)
};

const zh_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简介（选填）`)
};

const es_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción (opcional)`)
};

const pt_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição (opcional)`)
};

const id_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deskripsi (opsional)`)
};

const fr_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description (facultatif)`)
};

const tl_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paglalarawan (opsyonal)`)
};

const vi_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả (không bắt buộc)`)
};

const ko_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설명 (선택)`)
};

const de_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung (optional)`)
};

const ru_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание (необязательно)`)
};

const tr_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açıklama (isteğe bağlı)`)
};

const it_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione (facoltativa)`)
};

const pl_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opis (opcjonalnie)`)
};

const uk_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опис (необов'язково)`)
};

const hi_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण (वैकल्पिक)`)
};

const ar_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصف (اختياري)`)
};

const ms_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keterangan (pilihan)`)
};

const bn_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিবরণ (ঐচ্ছিক)`)
};

const zh_tw2_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`說明（選填）`)
};

const zh_hk2_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`說明（選填）`)
};

const ur_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفصیل (اختیاری)`)
};

const fa_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توضیح (اختیاری)`)
};

const sw_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maelezo (si lazima)`)
};

const nl_event_description_placeholder = /** @type {(inputs: Event_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omschrijving (optioneel)`)
};

/**
* | output |
* | --- |
* | "Description (optional)" |
*
* @param {Event_Description_PlaceholderInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_description_placeholder = /** @type {((inputs?: Event_Description_PlaceholderInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Description_PlaceholderInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_description_placeholder(inputs)
	if (locale === "ja") return ja_event_description_placeholder(inputs)
	if (locale === "zh") return zh_event_description_placeholder(inputs)
	if (locale === "es") return es_event_description_placeholder(inputs)
	if (locale === "pt") return pt_event_description_placeholder(inputs)
	if (locale === "id") return id_event_description_placeholder(inputs)
	if (locale === "fr") return fr_event_description_placeholder(inputs)
	if (locale === "tl") return tl_event_description_placeholder(inputs)
	if (locale === "vi") return vi_event_description_placeholder(inputs)
	if (locale === "ko") return ko_event_description_placeholder(inputs)
	if (locale === "de") return de_event_description_placeholder(inputs)
	if (locale === "ru") return ru_event_description_placeholder(inputs)
	if (locale === "tr") return tr_event_description_placeholder(inputs)
	if (locale === "it") return it_event_description_placeholder(inputs)
	if (locale === "pl") return pl_event_description_placeholder(inputs)
	if (locale === "uk") return uk_event_description_placeholder(inputs)
	if (locale === "hi") return hi_event_description_placeholder(inputs)
	if (locale === "ar") return ar_event_description_placeholder(inputs)
	if (locale === "ms") return ms_event_description_placeholder(inputs)
	if (locale === "bn") return bn_event_description_placeholder(inputs)
	if (locale === "zh-TW") return zh_tw2_event_description_placeholder(inputs)
	if (locale === "zh-HK") return zh_hk2_event_description_placeholder(inputs)
	if (locale === "ur") return ur_event_description_placeholder(inputs)
	if (locale === "fa") return fa_event_description_placeholder(inputs)
	if (locale === "sw") return sw_event_description_placeholder(inputs)
	if (locale === "nl") return nl_event_description_placeholder(inputs)
	return en_event_description_placeholder(inputs)
});